<template>
  <v-container fluid>
    <h4 class="mb-2" v-if="!showPasirasymai">Perduodami dokumentai</h4>
    <template v-if="checkingSign">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      Tikrinamas bylos parašas
    </template>
    <template v-if="loadingData && !checkingSign">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      Kraunamos bylos
    </template>
    <template v-if="!loadingData && !checkingSign && !hidePasirasymaiData">
      <v-data-table
        :headers="filteredHeaders"
        :items="itemsList"
        :loading="loadingData"
        :footer-props="{
          showFirstLastPage: true,
          showCurrentPage: true,
          itemsPerPageText: 'Rodyti po:',
          itemsPerPageAllText: 'visi',
          itemsPerPageOptions: itemsPerPageOptions,
        }"
        :hide-default-footer="hideFooter"
        :hide-default-header="showPasirasymai"
        :items-per-page="pageSize"
      >
        <template #[`item.byla`]="{ item }">
          <el-byla
            :key="item.byl_id"
            :byla="item"
            with-name
            long-name
            modal-name
          />
        </template>
        <template #[`item.actions`]="{ item }">
          <template v-if="showPasirasymai">
            <div
              class="d-flex flex-row mb-1"
              v-for="pasirasymas in item.pasirasymai"
              :key="pasirasymas.psr_id"
            >
              <div class="d-flex pr-2">
                <div v-if="!pasirasymas.psr_pasirasyta">
                  <v-icon v-if="item.byl_pasirasyta" color="red"
                    >mdi-checkbox-blank-outline</v-icon
                  >
                </div>
                <div v-if="pasirasymas.psr_pasirasyta">
                  <v-icon v-if="item.byl_pasirasyta" color="green"
                    >mdi-checkbox-marked-outline</v-icon
                  >
                </div>
              </div>
              <div class="d-flex text-left">
                {{
                  !!pasirasymas.atstovas_asm_pavadinimas
                    ? pasirasymas.atstovas_asm_pavadinimas
                    : pasirasymas.asm_pavadinimas
                }}
              </div>
            </div>
          </template>
          <template v-if="!showPasirasymai">
            <v-icon v-if="item.byl_pasirasyta" color="green"
              >mdi-checkbox-marked-outline</v-icon
            >
            <v-chip
              color="default"
              small
              outlined
              class="mr-2"
              v-if="!item.reikia_pasirasyti"
            >
              nepasirašoma
            </v-chip>
          </template>
        </template>
        <template slot="loading">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
          Generuojamos bylos pasirašymui
        </template>
        <template slot="no-results">
          Duomenų nėra
        </template>
        <template slot="no-data">
          Duomenų nėra
        </template>
        <template #[`footer.page-text`]="props">
          Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
          {{ props.itemsLength }}
        </template>
      </v-data-table>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ModalBusenaBylos',
  props: {
    busena: String,
  },
  data() {
    return {
      loading: true,
      checkingSign: false,
      busenaBylos: [],

      signStatus: {
        pasirasymas: true,
        bylu_generavimas: 1,
      },
      refreshTimer: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      abortLoading: false,
    }
  },
  computed: {
    ...mapGetters(['objektasID', 'signType', 'signTransactionID']),
    headers() {
      return [
        {
          text: 'Byla',
          align: 'start',
          sortable: false,
          value: 'byla',
        },
        {
          text: 'Pasirašyta',
          align: 'center',
          sortable: false,
          value: 'actions',
          width: 150,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.busenaBylos.map(byla => {
        byla.byl_url = `byla/${byla.byl_id}/${byla.byl_hash}/content`
        byla.obj_dokumento_numeris = byla.byl_dokumento_nr
        return byla
      })
    },
    showPasirasymai() {
      return this.busena === 'iregistruotas'
    },
    hidePasirasymaiData() {
      return this.showPasirasymai && this.itemsList.length === 0
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    refreshTimeout() {
      return 1000
    },
    loadingData() {
      return (
        this.signStatus.bylu_generavimas !== 2 &&
        this.signStatus.bylu_generavimas !== 4
      )
    },
    unsignedList() {
      return this.busenaBylos.filter(item => {
        return item.byl_pasirasyta === false && item.reikia_pasirasyti === true
      })
    },
    needSign() {
      return this.unsignedList.length > 0
    },
  },
  created() {
    this.abortLoading = false
    this.signAuth()
  },
  beforeDestroy() {
    this.abortLoading = true
  },
  methods: {
    getData() {
      this.loading = true
      this.showFail = false
      this.$axios
        .get(`objektas/${this.objektasID}/busena/${this.busena}/bylos`)
        .then(res => {
          this.signStatus = res.data.status
          if (!this.loadingData) {
            this.busenaBylos = res.data.bylos
          }
          this.checkLoading()
        })
        .catch(err => {
          if (err.response) {
            window._VMA.$emit('DATA_ERROR', err.response.data.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    checkLoading() {
      if (this.loadingData && !this.abortLoading) {
        if (!this.refreshTimer) {
          this.refreshTimer = setInterval(() => {
            if (this.refreshTimer) {
              this.getData()
            }
          }, this.refreshTimeout)
        }
      } else {
        this.stopLoading()
      }
    },
    stopLoading() {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
      this.$emit('stopLoading', this.unsignedList)
    },
    signAuth() {
      if (!this.signType || !this.signTransactionID) {
        this.getData()
        return
      }
      this.checkingSign = true

      const signData = {
        signType: this.signType,
        transactionID: this.signTransactionID,
      }

      this.$axios
        .post(`objektas/${this.objektasID}/pasirasymas/tikrinti`, signData)
        .then(res => {
          this.$store.dispatch('signTransactionID', null)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.checkingSign = false
          this.getData()
        })
    },
  },
}
</script>
<style lang="scss" scoped></style>
